import { MutationTree } from 'vuex'
import GlobalState from '@/store/modules/global/GlobalState'

export const mutations: MutationTree<GlobalState> = {
  setTheme (state, theme) {
    state.isDarkTheme = theme
  },
  setLanguageCode (state, languageCode) {
    state.languageCode = languageCode
  },
  setApplication (state, application) {
    state.application = application
  }
}
